import zip from "lodash/zip";

export const getTextBoxData = (
  question,
  cluster,
  crossTableRow,
  tableData,
  scalar_datasets,
  one_hot_datasets,
  open_responses,
  id_column
) => {
  let returnAnswersArray = [];

  if (!question) return returnAnswersArray;

  let closed = question.is_closed;
  let opened = question.is_open;
  let multi = question.is_multi;

  if (closed) {
    let targetScalarDataset = scalar_datasets.find(
      (s) => s.question.short_desc === question.short_desc
    );
    for (let i = 0; i < targetScalarDataset.dataset.length; i++) {
      let datasetValue = targetScalarDataset.dataset[i];
      let targetAnswer = targetScalarDataset.question.answers.find(
        (a) => a.id_ === datasetValue
      );
      returnAnswersArray.push(targetAnswer);
    }

    // filter when cluster selected
    returnAnswersArray = returnAnswersArray.filter((r) => r.desc === cluster.x);

    // filter when cross table row selected
    if (crossTableRow) {
      let rangeNumber = tableData[crossTableRow.id_ - 1][0];
      returnAnswersArray = returnAnswersArray.slice(0, rangeNumber);
    }

    return returnAnswersArray;
  }

  if (opened) {
    let targetOneHotDataset = one_hot_datasets.find(
      (s) => s.question.short_desc === question.short_desc
    );
    let targetOpenResponse = open_responses.find(
      (s) => s.question.short_desc === question.short_desc
    );
    // filter when cluster selected
    let clusterOrder = targetOneHotDataset.question.answers.find(
      (a) => a.desc === cluster.x
    );
    clusterOrder = targetOneHotDataset.question.answers.indexOf(clusterOrder);
    let targetDataset = targetOneHotDataset.dataset[clusterOrder];

    let tempArray = zip(targetDataset, targetOpenResponse.answers, id_column);

    returnAnswersArray = tempArray.filter((t) => t[0] !== null);

    for (let i = 0; i < returnAnswersArray.length; i++) {
      returnAnswersArray[i].interview_number = returnAnswersArray[i][2];
      returnAnswersArray[i].desc = returnAnswersArray[i][1];
    }

    // filter when cross table row selected
    if (crossTableRow) {
      let rangeNumberStart = 0;
      for (let i = 0; i < crossTableRow.id_ - 1; i++) {
        rangeNumberStart += tableData[i][0];
      }
      let rangeNumberEnd = tableData[crossTableRow.id_ - 1][0];
      returnAnswersArray = returnAnswersArray.slice(
        rangeNumberStart,
        rangeNumberStart + rangeNumberEnd
      );
    }

    return returnAnswersArray;
  }

  if (multi) {
    let targetOneHotDataset = one_hot_datasets.find(
      (s) => s.question.short_desc === question.short_desc
    );
    // filter when cluster selected
    let clusterOrder = targetOneHotDataset.question.answers.find(
      (a) => a.desc === cluster.x
    );
    clusterOrder = targetOneHotDataset.question.answers.indexOf(clusterOrder);
    let targetDataset = targetOneHotDataset.dataset[clusterOrder];

    let tempArray = zip(targetDataset, id_column);

    returnAnswersArray = tempArray.filter((t) => t[0] !== null);

    for (let i = 0; i < returnAnswersArray.length; i++) {
      returnAnswersArray[i].interview_number = returnAnswersArray[i][2];
      returnAnswersArray[i].desc = returnAnswersArray[i][1];
    }

    // filter when cross table row selected
    if (crossTableRow) {
      let rangeNumberStart = 0;
      for (let i = 0; i < crossTableRow.id_ - 1; i++) {
        rangeNumberStart += tableData[i][0];
      }
      let rangeNumberEnd = tableData[crossTableRow.id_ - 1][0];
      returnAnswersArray = returnAnswersArray.slice(
        rangeNumberStart,
        rangeNumberStart + rangeNumberEnd
      );
    }

    return returnAnswersArray;
  }
};
